<template>
  <div class="CampusActivities">
    <div class="onehome">
      <van-icon @click='back' class="return" color="#fff" name="arrow-left" />
      <h3 class="title">附近</h3>
      <div class="imgbox">
        <van-icon name="chat-o" size='.6rem' color='#fff' @click='toModule("/personal/News")' />
        <van-icon name="scan" style="margin-left:6px" color="#fff" size='.6rem' @click='toScan' />
      </div>
    </div>
    <div class="titlebox">
      <h3 class="titlef" @click='toModule("/humanResource/jobList")'>供求信息</h3>
      <p>特卖</p>
    </div>
    <van-list v-model="loading" :finished="finished" @load="loadMore">
      <div class="listbox" v-for="(item, index) in boxinfo" :key="index"  @click="detalis(item.activityId)">
        <div class="boxBig">
          <!-- <div class="state">{{(item.joinEndTime,item.beginTime,item.endTime) | stateFilter(item.joinEndTime,item.beginTime,item.endTime)}}</div> -->
          <img :src="item.banner" alt="" class="img_b">
          <div class="content">
            <van-notice-bar :text='item.title'/>
            <!-- <p class="jiaje textOver">价格：{{item.price==0?"免费":item.price}}</p> -->
            <p class="bowTime in_b">时间：{{ item.beginTime | DateFilter('yyyy-MM-dd')}} 至 {{ item.endTime | DateFilter('yyyy-MM-dd')}}</p>
            <p class="bowAddress textOver">地点：{{item.address}}</p>
            <!-- <p class="bowAddress in_b">名额：{{ item.showNum }}人</p> -->
          </div>
        </div>
      </div>
    </van-list>
    <van-tabbar v-model="active">
      <van-tabbar-item :to="`/index?parkId=${this.currentParkId}`"><div class="divicon"><van-icon size='22px' name="wap-home" />首页</div></van-tabbar-item>
      <van-tabbar-item to="/propertys"><div class="divicon"><van-icon size='22px' name="like-o" />服务</div></van-tabbar-item>
      <van-tabbar-item to="/humanResource/jobList"><div class="divicon"><van-icon size='22px' name="location-o" />附近</div></van-tabbar-item>
      <van-tabbar-item to="/parkCompleteSet/ExclusiveActivities"><div class="divicon"><van-icon size='22px' name="point-gift-o" />活动</div></van-tabbar-item>
      <van-tabbar-item to="/personal"><div class="divicon"><van-icon size='22px' name="contact" />我的</div></van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      active:2,
      pageIndex: 1,
      boxinfo: [],
      total: 0,
      loading: false,
      finished: false,
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
    }
  },
  methods: {
    detalis(activityId) {
      this.$router.push({ path: `/ActivitiesDetalis/${activityId}`, query:this.$route.query });
    },
    getinfo() {
      this.$http.post(`${this.URL_PREFIX}/app/get/activity/info/list`,{
        currPage: this.pageIndex,
        pageRows: 10,
        parkId: this.currentParkId,
      }).then((res) => {
        if(res.data.resCode === '10000') {
          this.total = res.data.resData.pageInfo ? res.data.resData.pageInfo.total : 0;
          const tempArr = res.data.resData.pageList ? res.data.resData.pageList : [];
          this.boxinfo = this.boxinfo.concat(tempArr);
          this.finished = this.boxinfo.length >= this.total ? true : false;
        }else{
          this.$toast(res.data.resDesc);
        }
        this.loading = false;
      });
    },
    back(){
        this.$router.go(-1);//返回上一层
    },
    toScan() {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else {

        this.getJsSdkConfigParams();
      }
    },
    // 获取微信扫码配置
    getJsSdkConfigParams() {
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
        url: location.href.split('#')[0]
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.scanConfig.appId = res.resData.appId;
          this.scanConfig.timestamp = res.resData.timestamp;
          this.scanConfig.nonceStr = res.resData.nonceStr;
          this.scanConfig.signature = res.resData.signature;
          this.config();
        } else {
          Toast.fail({ duration: 1500, message: res.resDesc });
        }
      });
    },
    // 扫码
    config() {
      wx.config({
        debug: false,
        appId: this.scanConfig.appId,
        timestamp: this.scanConfig.timestamp,
        nonceStr: this.scanConfig.nonceStr,
        signature: this.scanConfig.signature,
        jsApiList: ['checkJsApi', 'scanQRCode']
      });


      // 配置出错
      wx.error((res) => {
        Toast.fail({ duration: 1500, message: `${res.errMsg}` });
      });

      // 配置成功之后的回调
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList : ['scanQRCode'],
          success : (res) => {
          }
        });
        wx.scanQRCode({
          /**
           * 此处为0才能使用PC官网的扫一扫登陆功能
           * 因为微信的登陆二维码做了特殊处理，必须直接由微信扫码跳转过去才行
           * 例如把微信登陆二维码识别为文本url后再点击也是不行的，必须由微信直接扫码跳转（微信会识别来源方式）
           * 所以如果要兼容官网微信登陆功能，这里就无法由我们自行处理二维码内容
           */
          needResult : 0,
          scanType : ["qrCode"],
        });
      });
    },
    toModule(path) {
      this.$router.push({ path: path });
    },
    loadMore() {
      if (this.boxinfo.length >= this.total) {
        return;
      }
      this.loading = true;
      this.pageIndex++;
      this.getinfo();
    },
  },
  mounted() {
    this.getinfo();
  },
  computed: {
    ...mapGetters(['currentParkId','token']),
  },
}
</script>
<style lang="scss" scoped>
.CampusActivities{
  // padding: .293333rem .32rem;
  .van-list{
    padding-bottom: 1.2rem;
  }
  .van-notice-bar{
    padding: 0px;
    background: #fff;
    height: auto;
    font-size: .453333rem;
    color: #333;
    font-weight: 700;
  }
  .divicon{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i{
      padding-bottom: .1rem;
    }
  }
  .listbox{
    padding: .2rem .2rem;
    background: #fff;
    margin-bottom: .2rem;
    height: 3.6rem;
  }
  .onehome{
    background: #205eff;
    width: 100%;
    height: 1.2rem;
    display: flex;
    justify-content:space-between;
    align-items: center;
    .return{
      padding-left: .18rem;
    }
    .title{
      text-align: center;
      color: #fff;
      padding-left: .88rem;
    }
    .imgbox{
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: .18rem;
    }
  }
  .titlebox{
    padding: 0.32rem 0.48rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    background: #fff;
    h3{
      margin-right: .3rem;
    }
    p{
      color: #000;
      font-weight: 600;
    }
  .titlef{
      // height: .6rem;
      color: #949fa6;
      border-left:4px solid #288ff8;
      padding-left: 0.24rem;
    }
  }
  .boxBig{
    background-color: #fff;
    width: 100%;
    height: 100%;
    border-radius: .106667rem;
    margin-bottom: .266667rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .state {
       background-color: #D92121;
       font-size: .4rem;
       position: absolute;
       z-index: 999;
       margin-top: .266667rem;
       color: #fff;
       border-radius: 0.1875rem;
       padding: 0.125rem .453333rem;
     }
    .img_b{
      display: inline-block;
      border-radius: .106667rem .106667rem 0 0;
      // width: 100%;
      width: 3.653333rem;
      height: 68%;
      object-fit: cover;
    }
    .content{
      width: 60%;
      // padding: .266667rem .32rem;
      p{
        color: rgb(153, 153, 153);
      }
      .bowTitle{
        font-size: .453333rem;
        color: rgb(51, 51, 51);
        font-weight: bold;
      }
      .jiaje{
        color: #D92121;
        font-size: .4rem;
      }
      .bowAddress{
        font-size: .32rem;
        margin-top: .06667rem;
      }
      .bowTime{
        font-size: .32rem;
        margin-top: .06667rem;
      }
      .bowNum{
        font-size: .32rem;
        margin-left: .266667rem;
        margin-top: .106667rem;
      }
    }
    
  }
}
.in_b{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/parkCompleteSet/components/CampusActivities.vue